import { Vendor } from 'types';
import { Sort } from './types';

export const vendorNameCompareFn = (a: Vendor, b: Vendor, sort: Sort) => {
	if (sort === 'asc') {
		return a.name.localeCompare(b.name) === -1 ? 1 : -1;
	} else {
		return a.name.localeCompare(b.name) === -1 ? -1 : 1;
	}
	// return 0;
};

export const vendorEmailCompareFn = (a: Vendor, b: Vendor, sort: Sort) => {
	if (sort === 'asc') {
		return a.email.localeCompare(b.email) === -1 ? 1 : -1;
	} else {
		return a.email.localeCompare(b.email) === -1 ? -1 : 1;
	}
	// return 0;
};
